var _path, _path2, _path3, _path4, _path5, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLandline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.52 28.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_landline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.84,22.15H19.66V20.06A2.09,2.09,0,0,1,21.75,18h0a2.1,2.1,0,0,1,2.09,2.09Z",
    transform: "translate(-8.11 -10.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.21,22.15H27V20.06A2.1,2.1,0,0,1,29.12,18h0a2.09,2.09,0,0,1,2.09,2.09Z",
    transform: "translate(-8.11 -10.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41,23.41a4.89,4.89,0,0,1-.72.5,5.21,5.21,0,0,1-.85.43,1.75,1.75,0,0,1-1.63-.2l-5.52-3.95a1.28,1.28,0,0,1-.53-1.36,4.69,4.69,0,0,1,.92-1.73,18.94,18.94,0,0,0-14.45-.22,4.65,4.65,0,0,1,.87,1.77,1.29,1.29,0,0,1-.69,1.42l-6.24,3.45a1.72,1.72,0,0,1-1.74,0h0a5.08,5.08,0,0,1-.7-.52,4.38,4.38,0,0,1,.1-6.8c8.75-7.38,22.76-7.17,31.29.46A4.38,4.38,0,0,1,41,23.41Z",
    transform: "translate(-8.11 -10.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93,78.75",
    transform: "translate(-8.11 -10.75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39,30.09a13.95,13.95,0,0,0-27.1,0,2.84,2.84,0,0,0-2.43,2.6V36.3A3,3,0,0,0,12.77,39H38.19a3,3,0,0,0,3.27-2.7V32.69A2.84,2.84,0,0,0,39,30.09ZM25.48,34a5.74,5.74,0,1,1,5.74-5.73A5.73,5.73,0,0,1,25.48,34Z",
    transform: "translate(-8.11 -10.75)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.37,
    cy: 17.51,
    r: 4.92
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLandline);
export default __webpack_public_path__ + "static/media/ic_landline.211a2490fa615d266e2208b3d79cdf90.svg";
export { ForwardRef as ReactComponent };